import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import {
    ReactiveFormsModule,
    FormsModule
} from "@angular/forms";
import { RouterModule } from "@angular/router";
import { PipesModule } from "../../../pipes/pipes.module";
import { MaterialModule } from "../../../components/material/material.module";
import { AccesorioService } from "../../../providers/accesorio.service";
import { AccesorioComponent } from "./accesorio/accesorio.component";
import { CrearAccesorioComponent } from "./crear-accesorio/crear-accesorio.component";
import { CrearAccesorioDialog } from "./crear-accesorio/crear-accesorio-dialog/crear-accesorio-dialog.component";
import { EditarAccesorioComponent } from "./editar-accesorio/editar-accesorio.component";
import { EditarAccesorioDialog } from "./editar-accesorio/editar-accesorio-dialog/editar-accesorio-dialog.component";
import { EliminarAccesorioComponent } from "./eliminar-accesorio/eliminar-accesorio.component";
import { EliminarAccesorioDialog } from "./eliminar-accesorio/eliminar-accesorio-dialog/eliminar-accesorio-dialog.component";
import { IrAccesorioComponent } from "./ir-accesorio/ir-accesorio.component";
import { VerAccesoriosComponent } from "./ver-accesorios/ver-accesorios.component";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        RouterModule,
        MaterialModule,
    ],
    declarations: [
        AccesorioComponent,
        CrearAccesorioComponent,
        CrearAccesorioDialog,
        EditarAccesorioComponent,
        EditarAccesorioDialog,
        EliminarAccesorioComponent,
        EliminarAccesorioDialog,
        IrAccesorioComponent,
        VerAccesoriosComponent,
    ],
    providers: [
        AccesorioService
    ],
    entryComponents: [
        CrearAccesorioDialog,
        EditarAccesorioDialog,
        EliminarAccesorioDialog,
    ],
    exports: [
        AccesorioComponent,
        CrearAccesorioComponent,
        EditarAccesorioComponent,
        EliminarAccesorioComponent,
        IrAccesorioComponent,
        VerAccesoriosComponent,
    ]
})
export class AccesorioModule { }